<template>
    <div>
      <chanpin   page_type="2" user_type="2" chanpin_type="3"> </chanpin> 
    </div>
  </template>
  <script>
  import chanpin from '../../tongyong/chanpin.vue'
   
  export default {
  
    components: {
      chanpin: chanpin 
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
